import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";
import { getCopyright } from "@/i18n/translations";

export const Footer = () => {
  const { lang, t } = useLang();

  return (
    <footer
      data-testid="site-footer"
      className="bg-[hsl(var(--md-bone))] border-t border-[hsl(var(--md-line))]"
    >
      <div className="max-w-[1480px] mx-auto px-6 md:px-12 lg:px-16 pt-24 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-5">
            <p className="font-display text-[2rem] md:text-[2.5rem] leading-[1.05] text-[hsl(var(--md-ink))]">
              Maison&nbsp;Dodji
            </p>
            <p className="editorial-muted mt-4 max-w-md">
              {t.footer.tagline}
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="label-quiet mb-5">{t.footer.navTitle}</p>
            <ul className="space-y-3 font-body text-[14px]">
              <li><Link className="link-quiet" to="/maison" data-testid="footer-link-maison">{t.nav.maison}</Link></li>
              <li><Link className="link-quiet" to="/collection" data-testid="footer-link-collection">{t.nav.collection}</Link></li>
              <li><Link className="link-quiet" to="/univers" data-testid="footer-link-univers">{t.nav.univers}</Link></li>
              <li><Link className="link-quiet" to="/contact" data-testid="footer-link-contact">{t.nav.contact}</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="label-quiet mb-5">{t.footer.contactTitle}</p>
            <ul className="space-y-3 font-body text-[14px] text-[hsl(var(--md-ink))]">
              <li>
                <a href="mailto:contact@maisondodji.com" data-testid="footer-email" className="link-quiet">contact@maisondodji.com</a>
              </li>
              <li>
                <a href="https://www.maisondodji.com" data-testid="footer-website" className="link-quiet">www.maisondodji.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="hairline mt-20" />

        <div className="mt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="font-eyebrow text-[hsl(var(--md-stone))]">
            {getCopyright(lang)}
          </p>
          <p className="font-eyebrow text-[hsl(var(--md-stone))]">
            {t.footer.baseline}
          </p>
        </div>
      </div>
    </footer>
  );
};
